import { useListContext, useTranslate } from "ra-core";

// Hvor mange som er valgt, og om utvalget er denne siden eller alle treff
// (PRD US16.3). Brukes i handlingslinjene for massehandlinger.
export const useBulkScopeText = () => {
  const translate = useTranslate();
  const { selectedIds = [], data = [], total } = useListContext();
  const count = selectedIds.length;
  const onPage = new Set(data.map((r) => String(r.id)));
  if (total != null && total > 0 && count >= total) {
    return translate("crm.bulk.scope_all", {
      smart_count: count,
      _: "%{smart_count} valgt (alle treff) |||| Alle %{smart_count} treff er valgt",
    });
  }
  if (selectedIds.every((id) => onPage.has(String(id)))) {
    return translate("crm.bulk.scope_page", {
      smart_count: count,
      _: "%{smart_count} valgt på denne siden |||| %{smart_count} valgt på denne siden",
    });
  }
  return translate("crm.bulk.scope_pages", {
    smart_count: count,
    _: "%{smart_count} valgt, også på andre sider |||| %{smart_count} valgt, også på andre sider",
  });
};

export const BulkSelectionLabel = ({ className }: { className?: string }) => {
  const text = useBulkScopeText();
  return (
    <span className={className ?? "text-sm text-muted-foreground"}>{text}</span>
  );
};
